module.exports = __webpack_public_path__ + "static/media/firstSelfie.14f826e1.jpg";